export type MediaPropertiesType = {
  mediaId: string | null
  mediaType: (typeof TYPES)[keyof typeof TYPES]
  manifestUrl: string
  posterUrl: string | null
  mp4Url?: string | null
}

const PRODUCTS = {
  API_VIDEO: 'api_video',
  OVH_CLOUD: 'ovh_cloud',
} as const

const TYPES = {
  VOD: 'vod',
  LIVE: 'live',
} as const

const MEDIA_PREFIXES = {
  [PRODUCTS.API_VIDEO]: {
    [TYPES.VOD]: ['vi'],
    [TYPES.LIVE]: ['li', 'ls'],
  },
  [PRODUCTS.OVH_CLOUD]: {
    [TYPES.VOD]: ['vod_'],
    [TYPES.LIVE]: ['live_'],
  },
}

const startsWithOneOf = (mediaId: string, prefixes: string[]): boolean => {
  for (let i = 0; i < prefixes.length; i++) {
    if (mediaId.startsWith(prefixes[i])) {
      return true
    }
  }
  return false
}

export const getMediaPropertiesFromId = (
  mediaId: string,
  domain: string,
): MediaPropertiesType => {
  const product = startsWithOneOf(
    mediaId,
    Object.values(MEDIA_PREFIXES[PRODUCTS.OVH_CLOUD]).reduce(
      (allPrefixes, currrentPrefixes) => [...allPrefixes, ...currrentPrefixes],
      [],
    ),
  )
    ? PRODUCTS.OVH_CLOUD
    : PRODUCTS.API_VIDEO

  const type = startsWithOneOf(mediaId, MEDIA_PREFIXES[product][TYPES.LIVE])
    ? TYPES.LIVE
    : TYPES.VOD

  return {
    mediaId,
    mediaType: type,
    ...(product === PRODUCTS.OVH_CLOUD
      ? type === TYPES.LIVE
        ? {
            manifestUrl: `https://${domain}/${mediaId}.m3u8`,
            posterUrl: `https://${domain}/${mediaId}/poster.jpg`,
            mp4Url: null,
          }
        : {
            manifestUrl: `https://${domain}/vod/${mediaId}/hls/main.m3u8`,
            posterUrl: `https://${domain}/vod/${mediaId}/poster.jpg`,
            mp4Url: `https://${domain}/vod/${mediaId}/mp4/source.mp4`,
          }
      : type === TYPES.LIVE
        ? {
            manifestUrl: `https://${domain}/${mediaId}.m3u8`,
            posterUrl: `https://${domain}/${mediaId}/thumbnail.jpg`,
            mp4Url: null,
          }
        : {
            manifestUrl: `https://${domain}/vod/${mediaId}/hls/manifest.m3u8`,
            posterUrl: `https://${domain}/vod/${mediaId}/thumbnail.jpg`,
            mp4Url: `https://${domain}/vod/${mediaId}/mp4/source.mp4`,
          }),
  }
}
